export default __webpack_public_path__ + "static/media/illustration-study-3-w@2x.c48e0fa3.webp";